import React from 'react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import { formatDate, parseDate } from 'react-day-picker/moment';
import MaskedText from './MaskedText';
import { isValidDate, removeTime } from "../../helpers/dateTime";
import * as Tools from "../../helpers/Tools";

export default class DatePickerWithMaskedInput extends React.Component {
    constructor(props) {
        super(props);
        const { value } = this.props;
        this.state = {
            selectedDay: value ? value : undefined, month: undefined,
            valueEntered: false, touched: false, isEmpty: value ? false : true,
            hasFocus: false, tabToNextDateField: false, pristine: true, isDisabled: false
        };
        this.handleDayChange = this.handleDayChange.bind(this);
        this.handleYearMonthChange = this.handleYearMonthChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.onClear = this.onClear.bind(this);       
    }
    
    onClear() {
        this.setState({ selectedDay: "", isEmpty: true, touched: false, pristine: true}, () => {
            this.dateInput.input.input.value = "";
            this.dateInput.state.typedValue = "";  // making changes this way due to the existing open issue https://github.com/gpbl/react-day-picker/issues/977
            this.dateInput.state.month = undefined;               
            if (this.props.onChange)
                this.props.onChange("", false);
            if (this.props.onClear)
                this.props.onClear();
        });    
    }   


    handleInputChange(e) {
        const { value} = e.target;
        if (value.trim() === '') {            
            this.handleDayChange("", {}, this.dateInput);
            if (this.props.onClear)
                this.props.onClear();
            return;
        }
    }

    handleDayChange(selectedDay, modifiers, dayPickerInput) {
        const input = dayPickerInput.dateInput ? dayPickerInput.dateInput.getInput() : dayPickerInput.getInput();   
        this.setState({
            selectedDay,
            isEmpty: input.props && input.props.value && !input.props.value.trim(),
            isDisabled: modifiers.disabled === true
        }, () => {
            if (this.props.onChange)
                this.props.onChange(this.state.selectedDay, !this.state.isEmpty && !this.state.isDisabled);
        });
    }

    handleYearMonthChange(month) {
        //if (month < this.state.maxDate) //don't allow the user select future month/year which is greater than maxDate.
        //allowing user to select future month/year which is greater than maxDate since user may be selecting month before year and they'll get error feedback on input field
        this.setState({ month });

        if (this.props.onMonthChange) {
            this.props.onMonthChange(month);
        }
    }

    onLeave() {
        this.setState({ touched: true });
    }

    isValid(value) {
        const { minDate, maxDate } = this.props;

        //if (!value) {
        //    return false;
        //}

        if (!isValidDate(value)) {
            return false;
        }

        const dateValue = new Date(value);        
        return (!minDate || Tools.dateStringFormat(dateValue) >= Tools.dateStringFormat(minDate)) && (!maxDate || Tools.dateStringFormat(dateValue) <= Tools.dateStringFormat(maxDate));
    }

    YearMonthForm({ date, localeUtils, onChange, yearsBackward, yearsForward, minDate, maxDate }) {
        const currentYear = new Date().getFullYear();
        //let { minDate, maxDate } = { minDate, maxDate};
        let maxYear = yearsForward ? yearsForward : 100;

        if (!minDate && yearsBackward) {
            minDate = new Date(currentYear - yearsBackward, 0);
        }

        if (!maxDate && yearsForward) {
            maxDate = new Date(currentYear + yearsForward, 11);
        }

        let maxYeartoDisplay = new Date(currentYear + maxYear, 11);

        minDate = removeTime(minDate);
        maxDate = removeTime(maxDate);

        const months = localeUtils.getMonths();
        const years = [];

        if (minDate && maxDate) {
            for (let i = minDate.getFullYear(); i <= maxYeartoDisplay.getFullYear(); i += 1) {
                years.push(i);
            }
        }
        const handleChange = function handleChange(e) {
            const { year, month } = e.target.form;
            if (year && month) {
                onChange(new Date(year.value, month.value));
            }
        };

        return (
            <form className="DayPicker-Caption">
                <select name="month" onChange={handleChange} value={date.getMonth()}>
                    {months.map((month, i) => (
                        <option key={month} value={i}>
                            {month}
                        </option>
                    ))}
                </select>
                <span className="icon-dd" />
                {years.length === 0 ?
                    <span>&nbsp;&nbsp;{date.getFullYear()}</span> :
                    <select name="year" onChange={handleChange} value={date.getFullYear()}>
                        {years.map(year => (
                            <option key={year} value={year}>
                                {year}
                            </option>
                        ))}
                    </select>}
                {years.length === 0 ?
                    "" :
                    <span className="icon-dd" />
                }
            </form>
        );
    }

    render() {
        const { selectedDay, isDisabled, isEmpty, month, touched } = this.state;
        const { isMaskedDateInput, dateIconNeeded, className, required, hasFocus, minDate, maxDate, initialDate, showAsInvalid, inputErrorMsg, yearsBackward, yearsForward, showClearBtn } = this.props;
        const requiredInvalid = required && isEmpty;
        const isValid = (!isDisabled && !requiredInvalid && this.isValid(selectedDay)) && !showAsInvalid;
        const validationClass = isValid ? "" : " input-invalid";
        const dynamicClass = (!isEmpty ? " input-not-empty" : "") +
            (className ? " " + className + " " : "") + 
            (hasFocus ? " input-focused" : "") + 
            (touched ? " input-touched" : " input-untouched") + 
            (showAsInvalid ? " input-show-invalid" : "") + 
            validationClass;

        const dayPickerProps = {
            modifiers: { disabled: [{ after: maxDate }] },
            month: this.state.month === undefined ? (maxDate && maxDate < new Date() ? maxDate : new Date()) : month,
            fromMonth: initialDate || minDate,
            toMonth: maxDate,            
            captionElement: ({ date, localeUtils }) => (
                <this.YearMonthForm
                    date={date}
                    localeUtils={localeUtils}
                    onChange={this.handleYearMonthChange}
                    yearsBackward={yearsBackward}
                    yearsForward={yearsForward}
                    minDate={minDate}
                    maxDate={maxDate}
                />
            )
        };


        return (
            <div className={"il-group datePickerInput maskedDatePicker" + dynamicClass}>
                <DayPickerInput
                    value={selectedDay || ""}
                    formatDate={formatDate}
                    parseDate={parseDate}
                    placeholder="MM/DD/YYYY"
                    onDayChange={this.handleDayChange}
                    onDayPickerHide={() => this.onLeave()}
                    dayPickerProps={dayPickerProps}
                    component={MaskedText}
                    ref={(element) => this.dateInput = element}
                    inputProps={{ onChange: this.handleInputChange, onClear: this.onClear }}  
                    keepFocus={false}
                />
                {showClearBtn && selectedDay &&
                    <div className="clear-btn-container">
                        <button className="clear-btn" type="button" aria-label="clear button" onClick={this.onClear}><span className="icon-input-clear" /></button>
                    </div>
                }
                {dateIconNeeded && <div className="input-icon-append"><span className="icon-calendar-form" /></div>}
                {!isValid && <div className="input-error-msg">{inputErrorMsg ? inputErrorMsg : !isEmpty ? "Please enter a valid date of birth." : ""}</div>}
            </div>
        );
    }
}

